import React from 'react'
import { inject, observer } from 'mobx-react'
import UserMarkerfileListContainer from './UserMarkerfileListContainer'
import UserMarkerfileSheetList from './UserMarkerfileSheetList'

const UserMarkerfilePane = ({ userMarkerfileList }) => (
  userMarkerfileList.selectedFile === null
    ? (
      <UserMarkerfileListContainer
        userMarkerfileList={userMarkerfileList}
      />
      )
    : (
      <UserMarkerfileSheetList
        userMarkerfileList={userMarkerfileList}
        markerfile={userMarkerfileList.selectedFile}
      />
      )
)

export default inject('selectionStore')(
  observer(UserMarkerfilePane)
)
